export default __webpack_public_path__ + "static/media/users-white.765d122d.svg";